import { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import SimulatorRedrural from '../../components/SimulatorRedrural';
import { HOST_API } from '../../config/hosts';
import { Box, CircularProgress } from '@mui/material';
import api from '../../services/api';

const FinancialSimulation = () => {
  const { id } = useParams();
  const [selectedSimulation, setSelectedSimulation] = useState(null);
  const [simulatorConfig, setSimulatorConfig] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchSimulation = useCallback(async () => {
    try {
      setLoading(true);
      const res = await api.get(`${HOST_API}/v1/simulation/${id}`);
      setSelectedSimulation(res.data.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchSimulatorConfig = useCallback(async () => {
    try {
      const res = await api.get(`${HOST_API}/v1/simulation/config`);
      setSimulatorConfig(res.data.data ?? null);
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    fetchSimulatorConfig();
  }, []);

  useEffect(() => {
    if (!id) return;
    fetchSimulation();
  }, [id]);

  if (loading)
    return (
      <Box
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}
      >
        <CircularProgress sx={{ color: '#83D84D' }} />
      </Box>
    );

  return <SimulatorRedrural simulation={selectedSimulation} simulatorConfig={simulatorConfig} />;
};

export default FinancialSimulation;
